import { useEffect, useState } from "react";
import { MessageSquareText, Play } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function SmsStatus() {
  const [status, setStatus] = useState(null);
  const [running, setRunning] = useState(false);

  const load = () => api.get("/admin/sms/status").then((r) => setStatus(r.data)).catch(() => {});
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const run = async () => {
    setRunning(true);
    try {
      const { data } = await api.post("/admin/sms/run-reminders");
      toast.success(`Reminder sweep done — 24h: ${data["24h"]}, 2h: ${data["2h"]}`);
      await load();
    } catch {
      toast.error("Could not run reminders");
    } finally {
      setRunning(false);
    }
  };

  if (!status) return null;

  return (
    <div className="mt-12 cj-card p-6" data-testid="sms-status-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-[#ff6b00]/10 flex items-center justify-center">
            <MessageSquareText className="h-5 w-5 text-[#ff6b00]" />
          </div>
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#ff6b00]">SMS reminders</div>
            <div className="font-display uppercase font-extrabold text-xl text-slate-100">24 h & 2 h before each detail</div>
          </div>
        </div>
        <span
          className={`cj-pill border ${status.configured ? "bg-emerald-500/10 text-emerald-300 border-emerald-500/30" : "bg-amber-500/10 text-amber-300 border-amber-500/30"}`}
          data-testid="sms-configured-badge"
        >
          {status.configured ? `Live · ${status.from_number}` : "Dormant · add Twilio keys"}
        </span>
      </div>
      {!status.configured && (
        <p className="text-sm text-slate-400 mt-4">
          Add <span className="font-mono text-slate-200">TWILIO_ACCOUNT_SID</span>, <span className="font-mono text-slate-200">TWILIO_AUTH_TOKEN</span> and{" "}
          <span className="font-mono text-slate-200">TWILIO_FROM_NUMBER</span> to the app secrets and texts start flowing automatically. Until then, every reminder is logged below so nothing is lost.
        </p>
      )}
      <div className="mt-4 flex items-center justify-between">
        <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">Recent activity</div>
        <button onClick={run} disabled={running} data-testid="sms-run-now-button" className="cj-btn-ghost px-3 py-1.5 rounded-full text-xs inline-flex items-center gap-1">
          <Play className="h-3 w-3" /> {running ? "Running…" : "Run sweep now"}
        </button>
      </div>
      <div className="mt-2 space-y-1.5">
        {status.recent.length === 0 && <div className="text-sm text-slate-500">No reminders queued yet.</div>}
        {status.recent.map((r, i) => (
          <div key={`${r.created_at}-${r.kind}-${r.to}-${i}`} className="flex items-center justify-between gap-3 text-xs bg-[#0f1522] border border-white/5 rounded-lg px-3 py-2" data-testid={`sms-log-row-${i}`}>
            <span className="font-mono text-slate-400 truncate">{r.created_at?.slice(0, 16).replace("T", " ")} · {r.kind} → {r.to}</span>
            <span className={`cj-pill border shrink-0 ${r.status === "sent" ? "bg-emerald-500/10 text-emerald-300 border-emerald-500/30" : r.status === "failed" ? "bg-red-500/10 text-red-300 border-red-500/30" : "bg-white/5 text-slate-400 border-white/10"}`}>
              {r.status.replace("_", " ")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
